import React from 'react'
import {
  SelectConditionName,
  getSelectCondtionOptions,
} from '../../constants/conditions'
import { ConditionName, Option } from '../../actions'
import listenToClickOutside from 'react-onclickoutside'
import { formatCondition } from '../../utils'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'
import { OptionDropdown } from '../../../../view/OptionDropdown'
import { OptionDropdownItem } from '../../../../view/OptionDropdownItem'

function isListItem(el: any) {
  const cls = el.getAttribute('class')
  return el.tagName === 'LI' && (cls === 'item' || cls === 'item is-selected')
}

export const Button = ({
  selected,
  onClick,
}: {
  selected: any
  onClick: any
}) => {
  if (selected.length > 0) {
    return (
      <span
        onClick={onClick}
        css={css`
          padding-right: 5px;
        `}
      >
        <i
          className="icomoon icon-close1 right"
          css={css`
            font-size: 10px;
            color: ${colors.white10};
            &:before {
              font-size: 0.65rem;
              margin-left: 5px;
            }
          `}
        />
      </span>
    )
  } else {
    return (
      <IcomoonIcon
        name="arrow8-down"
        css={css`
          font-size: 10px;
          color: ${colors.white10};
          &:before {
            font-size: 0.65rem;
            margin-left: 5px;
          }
        `}
      />
    )
  }
}

const Error = ({ hasError }: { hasError: boolean }) => {
  return hasError ? <i className="icomoon icon--warning2 left" /> : null
}

export type ConditionProps = {
  name: SelectConditionName
  open: boolean
  selected: Option[]
  hasError: boolean
  onToggle: (cond: ConditionName) => any
  onRemove: (param: ConditionName) => any
  onSelect: (cond: ConditionName, option: Option) => any
}

export class Condition extends React.Component<ConditionProps> {
  handleSelect(option: Option) {
    this.props.onSelect(this.props.name, option)
  }

  handleToggle(target: EventTarget) {
    if (!isListItem(target)) {
      this.props.onToggle(this.props.name)
    }
  }

  handleClickOutside() {
    if (this.props.open) {
      this.props.onToggle(this.props.name)
    }
  }

  render() {
    const { name, selected, hasError } = this.props
    const conditionClass = `condition ${hasError ? 'error' : ''}`
    const options = getSelectCondtionOptions(name)
    return (
      <div
        className={conditionClass}
        css={
          hasError
            ? css`
                background-color: ${colors.cyan50};
                border-radius: 50px;
                color: ${colors.white10};
                display: inline-block;
                font-size: 13px;
                position: relative;
                &:last-child {
                  margin-right: 5px;
                }
                /* background-color: $error */
              `
            : css`
                background-color: ${colors.cyan50};
                border-radius: 50px;
                color: ${colors.white10};
                display: inline-block;
                font-size: 13px;
                position: relative;
                &:last-child {
                  margin-right: 5px;
                }
              `
        }
      >
        <li
          className="condition-label"
          onClick={(e) => this.handleToggle(e.target)}
          css={css`
            padding: 5px 10px 5px 15px;
            cursor: pointer;
          `}
        >
          <Error hasError={hasError} />
          <span
            css={css`
              padding-right: 5px;
            `}
          >
            {formatCondition(name, selected)}
          </span>
          <Button
            selected={selected}
            onClick={() => this.props.onRemove(this.props.name)}
          />
        </li>
        <OptionDropdown
          open={this.props.open}
          _css={css`
            max-height: 500px;
            max-width: 256px;
            overflow-y: auto;
          `}
        >
          {options.map(([option, value], i) => (
            <OptionDropdownItem
              key={i}
              idx={i}
              condition={selected.includes(option)}
              handleSet={() => this.handleSelect(option)}
              label={value.label}
            />
          ))}
        </OptionDropdown>
      </div>
    )
  }
}

// @ts-ignore
export default listenToClickOutside(Condition)
